/* eslint-disable no-param-reassign */
import axios, {
  dataAxios,
  transactionsAxios,
  collectionsAxios,
} from '../../util/Api';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  SELECTED_USER_DATA,
  USER_TOKEN_SET,
  SHOW_MESSAGE,
  SHOW_ERROR_MESSAGE,
  ACTIVATE_USER_INIT,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_ERROR,
  ACTIVATION_CODE_RECREATE_SUCCESS,
  SET_FORGOT_PASSWORD_EMAIL,
  FETCH_ROLES_START,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_ERROR,
  ADD_ROLE_START,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_ERROR,
  DELETE_ROLE_START,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  UPDATE_ROLE_START,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_ERROR,
  FETCH_USERS_START,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_ERROR,
  FETCH_PERMISSIONS_START,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_ERROR,
  ADD_PERMISSIONS_START,
  ADD_PERMISSIONS_SUCCESS,
  ADD_PERMISSIONS_ERROR,
  DELETE_PERMISSIONS_START,
  DELETE_PERMISSIONS_SUCCESS,
  DELETE_PERMISSIONS_ERROR,
  UPDATE_PERMISSIONS_START,
  UPDATE_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS_ERROR,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  ADD_USER_START,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  SET_SELECTED_USER,
  PASSWORD_RESET_INIT,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
  VERIFY_MFA_TOKEN_START,
  VERIFY_MFA_TOKEN_SUCCESS,
  VERIFY_MFA_TOKEN_ERROR,
  GET_MFA_QRCODE_START,
  GET_MFA_QRCODE_SUCCESS,
  GET_MFA_QRCODE_ERROR,
  TOGGLE_MFA_TOKEN_START,
  TOGGLE_MFA_TOKEN_SUCCESS,
  TOGGLE_MFA_TOKEN_ERROR,
  SIGNUP_USER_SUCCESS,
} from '../../constants/ActionTypes';
import encryptStorage from '../../util/encryption';

export const setInitUrl = (url) => ({
  type: INIT_URL,
  payload: url,
});

export const getAllUsers = (params = '', merchant = false) => (dispatch) => {
  dispatch({ type: FETCH_USERS_START });
  axios.get(`${merchant ? 'merchant/users' : 'users'}${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_USERS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_USERS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const getMerchantUsers = (params = '', merchant = false) => (dispatch) => {
  dispatch({ type: FETCH_USERS_START });
  axios.get(`users/${merchant ? 'merchants' : ''}${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_USERS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_USERS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addUser = (value) => (dispatch) => {
  dispatch({ type: ADD_USER_START });
  axios.post('users/', value).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: ADD_USER_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: `Created user: ${data.first_name}` });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: ADD_USER_ERROR });
    console.error('Error: ', error.message);
  });
};

export const updateUser = (userId, value) => (dispatch) => {
  dispatch({ type: UPDATE_USER_START });
  axios.put(`users/${userId}`, value).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: UPDATE_USER_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: `Updated user: ${data.first_name}` });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_USER_ERROR });
    console.error('Error: ', error.message);
  });
};

export const userSignUp = ({ email, password, merchant_type }) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.post('register', {
    email,
    merchant_type,
    password,
    username: email,
  }).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response && response.message && response.message === 'Successfully registered user!') {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SIGNUP_USER_SUCCESS, payload: response.data.user_id });
    }
  }).catch((error) => {
    dispatch({ type: FETCH_ERROR, payload: error.response.data.message });
    console.error('Error: ', error.message);
  });
};

export const userSignIn = ({
  email, password, otp, captcha_token,
}) => (dispatch) => {
  dispatch({ type: FETCH_START });
  return axios.post('login', {
    username: email,
    password,
    otp,
    captcha_token,
  }).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response?.data?.mfa_required) {
      dispatch({ type: FETCH_SUCCESS });
      return { mfaRequired: true };
    }
    if (response && response.data.user.role.name) {
      const data = response.data;
      encryptStorage.setItem('token', data.token);
      encryptStorage.setItem('user', JSON.stringify(data.user));

      [axios, dataAxios, transactionsAxios, collectionsAxios].map(
        (instance) => instance.interceptors.request.use((config) => {
          config.headers.Authorization = data.token;
          return config;
        }),
      );
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: USER_TOKEN_SET, payload: data.token });
      dispatch({ type: USER_DATA, payload: data.user });
    } else {
      dispatch({ type: FETCH_ERROR, payload: response.data.message || 'Not Authorized' });
    }
    return { mfaRequired: false };
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
    return { mfaRequired: false, failed: true };
  });
};

export const activateAccount = ({ userId, secretCode }) => (dispatch) => {
  dispatch({ type: FETCH_START });
  dispatch({ type: ACTIVATE_USER_INIT });
  axios.post('accounts/activate', { userId, secretCode }).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response && response.message && response.message === 'Account activated successfully') {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SHOW_MESSAGE, payload: response.message });
      dispatch({ type: ACTIVATE_USER_SUCCESS, payload: response.data });
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'We were unable to activate your account, please try again';
      dispatch({ type: ACTIVATE_USER_ERROR, payload: message });
    }
    console.error('Error: ', error.message);
  });
};

export const resetActivateAccount = () => (dispatch) => {
  dispatch({ type: ACTIVATE_USER_SUCCESS, payload: {} });
  dispatch({ type: ACTIVATE_USER_ERROR, payload: null });
};

export const generateNewCode = ({ userId }) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.get(`accounts/activation-code/${userId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response && response.message) {
      dispatch({ type: SHOW_MESSAGE, payload: response.message });
      dispatch({ type: ACTIVATION_CODE_RECREATE_SUCCESS, payload: response.message });
      dispatch({ type: FETCH_SUCCESS });
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'We were unable to generate a new code, please try again';
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: message });
    }
    console.error('Error: ', error);
  });
};

export const getUser = (id) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.get(`users/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: USER_DATA, payload: data.user });
    }
  }).catch((error) => {
    dispatch({ type: FETCH_ERROR, payload: error.message });
    console.error('Error: ', error.message);
  });
};

export const getSelectedUser = (id) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.get(`users/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SELECTED_USER_DATA, payload: data });
    }
  }).catch((error) => {
    dispatch({ type: FETCH_ERROR, payload: error.message });
    console.error('Error: ', error.message);
  });
};

export const userSignOut = () => (dispatch) => {
  encryptStorage.removeItem('token');
  encryptStorage.removeItem('user');
  // encryptStorage.removeItem('activeMerchant');

  dispatch({ type: FETCH_START });
  dispatch({ type: SIGNOUT_USER_SUCCESS });
  dispatch({ type: FETCH_SUCCESS });
};

export const updatePassword = (id, user, merchant = null) => (dispatch, getState) => {
  dispatch({ type: FETCH_START });
  axios.put(`users/${id}`, user).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SHOW_MESSAGE, payload: 'Your password has been reset' });
      // Changing a password invalidates the current session, so sign out when it is our own
      const ownId = getState().auth.authUser?._id;
      if (!merchant || id === ownId) {
        dispatch(userSignOut());
      }
    }
  }).catch((error) => {
    if (error && error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR, payload: '' });
    console.error('Error: ', error);
  });
};

export const updateUserInfo = (id, userData) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.put(`users/${id}`, userData).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: USER_DATA, payload: data });
      encryptStorage.setItem('user', JSON.stringify(data));
    }
  }).catch((error) => {
    if (error && error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR, payload: '' });
    console.error('Error: ', error);
  });
};

export const forgotPassword = (email) => (dispatch) => {
  dispatch({ type: FETCH_START });
  axios.post('password-reset', email).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SET_FORGOT_PASSWORD_EMAIL, payload: email.email });
      dispatch({ type: SHOW_MESSAGE, payload: response.message });
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const resetPassword = (resetData) => (dispatch) => {
  dispatch({ type: FETCH_START });
  dispatch({ type: PASSWORD_RESET_INIT });
  axios.post('save-password', resetData).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data) {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SHOW_MESSAGE, payload: data.message });
      dispatch({ type: PASSWORD_RESET_SUCCESS, payload: response.message });
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: PASSWORD_RESET_ERROR, payload: error.message });
    dispatch({ type: FETCH_ERROR });
    console.error('Error: ', error.message);
  });
};

export const getRoles = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_ROLES_START });
  axios.get(`roles/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_ROLES_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_ROLES_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addRole = (role) => (dispatch) => {
  dispatch({ type: ADD_ROLE_START });
  axios.post('roles/', role).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data && data.name !== 'MongoError') {
      dispatch({ type: ADD_ROLE_SUCCESS, payload: data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added role: ${data.name}` });
    } else {
      dispatch({ type: ADD_ROLE_ERROR });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', data);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_ROLE_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const updateRole = (roleId, value) => (dispatch) => {
  dispatch({ type: UPDATE_ROLE_START });
  axios.put(`roles/${roleId}`, value).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: UPDATE_ROLE_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: `Updated role: ${data.name}` });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_ROLE_ERROR });
    console.error('Error: ', error.message);
  });
};

export const setSelectedUserId = (user) => (dispatch) => {
  dispatch({ type: SET_SELECTED_USER, payload: user });
};

export const deleteRole = (roleId) => (dispatch) => {
  dispatch({ type: DELETE_ROLE_START });
  axios.delete(`roles/${roleId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_ROLE_SUCCESS, payload: roleId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: DELETE_ROLE_ERROR });
    console.error('Error: ', error.message);
  });
};

export const getPermissions = (params = '', options = {}) => (dispatch) => {
  dispatch({ type: FETCH_PERMISSIONS_START, search: options.search || false });
  axios.get(`permissions/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = {
      data: response.data, currentPage, totalItems, search: options.search || false,
    };
    dispatch({ type: FETCH_PERMISSIONS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_PERMISSIONS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addPermission = (permission) => (dispatch) => {
  dispatch({ type: ADD_PERMISSIONS_START });
  axios.post('permissions', permission).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_PERMISSIONS_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added permission: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_PERMISSIONS_ERROR, payload: response.data.name });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_PERMISSIONS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const deletePermission = (permissionId) => (dispatch) => {
  dispatch({ type: DELETE_PERMISSIONS_START });
  axios.delete(`permissions/${permissionId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_PERMISSIONS_SUCCESS, payload: permissionId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: DELETE_PERMISSIONS_ERROR });
    console.error('Error: ', error.message);
  });
};

export const updatePermission = (permissionId, values) => (dispatch) => {
  dispatch({ type: UPDATE_PERMISSIONS_START });
  axios.put(`permissions/${permissionId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: UPDATE_PERMISSIONS_SUCCESS, payload: permissionId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_PERMISSIONS_ERROR });
    console.error('Error: ', error.message);
  });
};

export const generateMFAQRCode = () => (dispatch, getState) => {
  const userId = getState().auth.authUser._id;
  dispatch({ type: GET_MFA_QRCODE_START });
  axios.get(`accounts/mfa-qr-code/${userId}`, { responseType: 'arraybuffer' }).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const blob = new Blob(
      [response.data],
      { type: axiosResponse.headers['content-type'] },
    );
    const image = URL.createObjectURL(blob);

    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully generated qrcode' });
    dispatch({ type: GET_MFA_QRCODE_SUCCESS, payload: image });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'We were unable to generate a new QRCode, please try again';
      dispatch({ type: GET_MFA_QRCODE_ERROR, payload: message });
    }
    console.error('Error: ', error);
  });
};

export const verifyMFAToken = (mfacode) => (dispatch, getState) => {
  const userId = getState().auth.authUser._id;

  dispatch({ type: VERIFY_MFA_TOKEN_START });
  axios.post(`accounts/mfa-verification/${userId}`, { secretCode: mfacode.code })
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      // TODO Check if verification was actually successful
      dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Successfully verified code' });
      dispatch({ type: VERIFY_MFA_TOKEN_SUCCESS, payload: response?.message || 'Verification success' });
    }).catch((error) => {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'We were unable to verify your MFA token, please try again' });
      const message = 'Unable to verify MFA token, please try again';
      dispatch({ type: VERIFY_MFA_TOKEN_ERROR, payload: message });
    });
};

export const toggleMFAToken = (mfacode) => (dispatch, getState) => {
  const userId = getState().auth.authUser._id;
  const userData = {
    ...getState().auth.authUser,
    is_2fa_enabled: !getState().auth.authUser.is_2fa_enabled,
  };
  dispatch({ type: TOGGLE_MFA_TOKEN_START });
  axios.post(`accounts/mfa-toggle/${userId}`, { secretCode: mfacode.code })
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      //TODO check if QR was actually successful
      dispatch({ type: SHOW_MESSAGE, payload: response?.message || 'Successfully enabled 2FA' });
      dispatch({ type: TOGGLE_MFA_TOKEN_SUCCESS, payload: response?.message || '2FA status changed' });
      dispatch({ type: USER_DATA, payload: userData });
      encryptStorage.setItem('user', JSON.stringify(userData));
    }).catch((error) => {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error?.response?.data?.message || 'Failed to change 2FA status' });
      const message = 'Unable to toggle MFA token, please try again';
      dispatch({ type: TOGGLE_MFA_TOKEN_ERROR, payload: message });
    });
};
